

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BIconDash, BIconHandThumbsDown, BIconHandThumbsUp } from 'bootstrap-vue';
import api from '@/api/apiclient';
import { IComment, IUser } from '@/api/interface';
import { emailRegexp } from '@/helpers/validation';
import MediaAlert from "@/components/MediaAlert.vue";

interface IOAuthProvider {
  id: string;
  href: string;
  title: string;
  icon: string;
}

@Component({
  components: {MediaAlert, BIconDash, BIconHandThumbsDown, BIconHandThumbsUp }
})
export default class CommentsForm extends Vue {

  @Prop({ default: 0 })
  private routeId!: number;

  @Prop({ default: '' })
  private oauthProviders!: string;

  private action = '/cms/api/comments/' + this.routeId;
  private userInfoUrl = '/cms/api/user';

  private form = {
    roboname: '',
    robochk: false,
    name: '',
    email: '',
    comment: '',
    rate: 0
  }

  private oauthProvidersData: IOAuthProvider[] = [
    { id: 'facebook', href: '/cms/oauth/facebook', title: 'Войти через Facebook', icon: 'icon-facebook' },
    { id: 'github', href: '/cms/oauth/github', title: 'Войти через Github', icon: 'icon-github-circled' },
    { id: 'google', href: '/cms/oauth/google', title: 'Войти через Google', icon: 'icon-google' },
    { id: 'yandex', href: '/cms/oauth/yandex', title: 'Войти через Яндекс', icon: 'icon-yandex' },
  ];

  private oauthProvidersEnabled: IOAuthProvider[] = [];

  private user: IUser | null = null;

  private sending = false;
  private showSuccess = 0;
  private showError = 0;
  private showOauth = 0;
  private errorMessage = '';

  emailState() {
    return !!this.user || this.form.email && !this.form.email.match(emailRegexp) ? false : null;
  }

  valid() {
    if (this.user) return !!this.form.comment;
    else return this.form.name && this.form.comment && this.form.email.match(emailRegexp);
  }

  mounted() {
    this.checkUserSession().then(user => {
      if (user) this.user = user;
      else {
        this.loadGuset();
        this.loadOAuthProviders();
      }
    });

    const w = window as any;
    if (!w.handleOAuth) {
      w.handleOAuth = () => this.handleOAuth();
    }
  }

  checkUserSession(force = false): Promise<IUser | null> {
    return new Promise(resolve => {
      if (force || this.$cookies.get('user_session') || this.$cookies.get('PHPSESSID')) {
        api.get<IUser>(this.userInfoUrl).then(resolve).catch(e => resolve(null));
      }
      else resolve(null);
    });
  }

  loadGuset() {
    const guest: { name: string, email: string } = this.$cookies.get('guest');
    if (guest) {
      this.form = Object.assign({}, this.form, guest);
    }
    return !!guest;
  }

  loadOAuthProviders() {
    const oauthIds = this.oauthProviders.split(',').map(a => a.trim());
    this.oauthProvidersEnabled = this.oauthProvidersData.filter(a => oauthIds.length && oauthIds.includes(a.id));
  }

  onSubmit(e: Event) {
    e.preventDefault();

    if (!this.user) {
      this.$cookies.set('guest', {
        name: this.form.name,
        email: this.form.email
      });
    }

    if (!this.valid()) return false;

    this.sending = true;
    api.post<IComment>(this.action, this.form)
        .then(comment => {
          this.$emit('added', comment);
          this.form.comment = '';
          this.form.rate = 0;
          this.showSuccess = 5;
        })
        .catch(e => {
          this.errorMessage = e.response?.data?.message || '';
          this.showError = 10;
        })
        .finally(() => this.sending = false);

    return false;
  }

  onOAuth(href: string) {
    window.open(href, 'oauth', 'height=600,width=1000');
  }

  handleOAuth() {
    this.checkUserSession(true).then(user => {
      if (user) {
        this.user = user;
      }
      else {
        console.log('Failed to get user after OAuth');
        this.showOauth = 10;
      }
    });
  }
}
